import * as React from 'react';
import { Dropdown, Header, Segment } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { DashboardRoute } from '~/Application/routes';
import { BetaLabel } from '~/BetaLabel';
export var BrandFilter = function (_a) {
    var filter = _a.filter, disabled = _a.disabled, brands = _a.brands, filteredBrands = _a.filteredBrands;
    var redirect = DashboardRoute.useRedirect();
    return disabled ? null : (<Segment>
			<Header.Content as='h5' floated='left'>
				<BetaLabel />
				Hledání dle brandu
			</Header.Content>
			<Dropdown allowAdditions fluid multiple search selection data-testid='brand-filter' options={brands.map(function (brand) { return ({ key: brand.value, text: brand.title, value: brand.value }); })} placeholder='Zadejte hledaný brand' 
    // Lint no-unused-variable does not work (possibly deprecated)
    value={filteredBrands} onChange={function (_event, data) {
            var _a;
            // tslint:disable-line: variable-name
            var values = (_a = data.value) !== null && _a !== void 0 ? _a : [];
            var hasBeenBrandAdded = values.length >= filteredBrands.length;
            if (hasBeenBrandAdded) {
                values.map(function (brand) {
                    redirect({ filter: filter.added({ type: InfoCardApi.TagType.brand, value: brand }) });
                });
            }
            else {
                var tags = values.map(function (brand) { return ({ type: InfoCardApi.TagType.brand, value: brand }); });
                redirect({ filter: filter.keep(tags, InfoCardApi.TagType.brand) });
            }
        }}/>
		</Segment>);
};
